import SecureMarkdown from '@components/SecureMarkdown'
import DisplayAttachment from '@components/DisplayAttachment/DisplayAttachment'

const AnswerDisplay = ({ answer, attachments = [] }) => (
  <div className='bg-gray-100 dark:bg-gray-800 p-3 rounded-lg mt-5'>
    <h3 className='text-lg font-semibold mb-2 text-gray-900 dark:text-gray-100'>Answer</h3>
    <SecureMarkdown content={answer || 'No answer was provided'} />

    {attachments?.length > 0 && (
      <div className='flex flex-wrap gap-3'>
        {attachments.map(attachment => (
          <DisplayAttachment
            key={attachment.id}
            id={attachment.id}
            filename={attachment.filename}
            url={attachment.url}
            outline={false}
          />
        ))}
      </div>
    )}
  </div>
)

export default AnswerDisplay 
